import React, { useMemo } from 'react';
import { Label } from '@atlaskit/form';
import { Flex } from '@atlaskit/primitives/compiled';

import { DataClassificationDropdown } from '@atlassian/data-classification-level';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

const DataClassificationField = (props: Props) => {
	const { width, value, onChange, allowedValues, errorMessage, isDisabled, nonEditableReason } =
		props;

	const { formatMessage } = useIntl();
	const attributes = useMemo(
		() => ({
			isDisabled,
		}),
		[isDisabled],
	);
	return (
		<JiraIssueCreateErrorBoundary
			id="dataClassificationField"
			packageName="jiraIssueCreateCommons"
			fallback="unmount"
			sendToPrivacyUnsafeSplunk
			{...(fg('jira-issue-create-error-boundary-enabled') ? { attributes } : {})}
		>
			<FieldContainer width={width} marginTop={gridSize * 2.25} paddingBottom={gridSize * 2.25}>
				<Label htmlFor="data-classification-dropdown-input" id="data-classification-select">
					<Flex justifyContent="start">{formatMessage(messages.classificationFieldLabel)}</Flex>
				</Label>
				<DataClassificationDropdown
					options={allowedValues}
					value={value}
					onChange={onChange}
					isDisabled={isDisabled}
					disabledTooltipMessage={nonEditableReason?.message}
					errorMessage={errorMessage}
				/>
			</FieldContainer>
		</JiraIssueCreateErrorBoundary>
	);
};

export default DataClassificationField;
